import * as React from 'react';
import global from '../css/Global.module.css';
import setupTemplates from '../bin/images/setupTemplates.png';
import { NavLink, BrowserRouter as Router } from 'react-router-dom';

function LeftFacingHeroBlock(props) {
    return (
        <div className={[global.monolith, global.leftImgMonolith].join(' ')}>
            <div className={global.monolithInner}>
                <div className={global.imageContainer}><img className={global.imgSetupTemplate} src={props.titleImg}></img></div>
                <div className={global.featureOverview}>
                    {props.titleTag && <div className={global.featureTag}>{props.featureTag}</div>}
                    <div className={global.featureTitle}>{props.featureTitle}</div>
                    {Array.isArray(props.featureBlurbList) && props.featureBlurbList.length > 0 ? (
                        <ul className={global.featureBlurbList}>
                            {props.featureBlurbList.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    ) : (
                        props.featureBlurb ? <p className={global.featureBlurb}>{props.featureBlurb}</p> : null
                    )}
                </div>
            </div>
        </div>
    );
}

export default LeftFacingHeroBlock;